<template>
    <div>
        <v-card>
            <s-toolbar label="Reporte de Entrega" dark color="#8e8f91" excel @excel="downloadExcel()">
                <div style="display: flex; justify-content: space-between">
                    <div style="display: flex;">
                        <div>
                            <v-text-field id="tour-search" style="margin-top:-1px; width:150px !important;" ref="buscar" height="30"
                                width="60" v-model="textSearch" dense clearable hide-details @keyup.enter="clickSearch()"/>
                        </div>
                        <v-tooltip bottom="">
                            <template v-slot:activator="{ on }">
                                <v-btn :color="'white'" text v-on="on" small @click="clickSearch()"> <v-icon> mdi-magnify</v-icon></v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                        <v-tooltip bottom="">
                            <template v-slot:activator="{ on }">
                                <v-btn :color="'white'" text v-on="on" small @click="startTour()"> <v-icon>mdi-help-circle-outline</v-icon></v-btn>
                            </template>
                            <span>Iniciar Tutorial</span>
                        </v-tooltip>
                    </div>
                </div>
            </s-toolbar>
            <v-container>
				<v-row justify="center">
					<v-col cols="12" md="3" id="tour-client">
						<sselect-client-sap
							label="Cliente"
							v-model="filter.CustomerID"
						></sselect-client-sap>
					</v-col>
                    <v-col cols="12" md="3" id="tour-campaign">
                        <s-select-campaign
                            label="Campaña"
                            v-model="filter.CmpID"
                            clearable
                        />
                    </v-col>
                    <v-col cols="12" md="3" id="tour-cultive">
                        <s-select-definition 
                            :def="1173" 
                            label="Tipo de Cultivo"
                            v-model="filter.TypeCultive"
                        />
                    </v-col>
					<v-col cols="12" md="3" id="tour-container">
                        <v-switch
                            label="Por contenedor"
                            v-model="filter.ShowContainers"
                        />
                    </v-col>
                    <v-col cols="12" md="3" v-if="filter.ShowContainers">
                        <v-text-field
                            label="WeekNumber"
                            v-model="filter.WeekNumber"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <delivery-container-report
                            v-if="filter.ShowContainers"
                            :report-data="containerReportData"
                        />
                        <v-data-table
                            v-else
                            id="tour-table"
                            item-key="Line"
                            dense
                            fixed-header
                            :items="items"
                            :headers="headers"
                            :items-per-page="20"
                            v-model="selected"
                            :loading="loading"
                        ></v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </div>
</template>
  
<script>
    import _sDeliveryService from '@/services/ExternalTrade/ExtDeliveryService.js';
	import SselectClientSap from '@/components/Sale/SselectClientSap.vue';
    import DeliveryContainerReport from './DeliveryContainerReport.vue';
    import { driver } from "driver.js";
    import "driver.js/dist/driver.css";

	export default {
		components: {
			SselectClientSap,
            DeliveryContainerReport
		},
        data() {
            return {
                filter:{
                    CmpID: 0,
                    TypeCultive: 0,
					CustomerID: null,
					ShowContainers: false,
                    WeekNumber: null,
                },
				textSearch: '',
				selected: [],
				loading: false,
				items: [],
				headers: [],
				debounceTimer: null,
                driverObj: null,
                containerReportData: {
                    containers: [],
                    detail: [],
                    totalByContainer: [],
                    grandTotal: 0
                }
            }
        },
        mounted() {
            this.driverObj = driver({
                showProgress: true,
                steps: [
                    { popover: { title: 'Bienvenido', description: 'Este es el módulo de Reporte de Entrega. Aquí podrás consultar y exportar información de entregas.' } },
                    { element: '#tour-search', popover: { title: 'Búsqueda Rápida', description: 'Utiliza este campo para buscar entregas específicas por texto y el boton para buscar con los filtros aplicados.' } },
                    { element: '#tour-client', popover: { title: 'Filtrar por Cliente', description: 'Selecciona un cliente específico para ver sus entregas.' } },
                    { element: '#tour-campaign', popover: { title: 'Filtrar por Campaña', description: 'Filtra los resultados por campaña.' } },
                    { element: '#tour-cultive', popover: { title: 'Tipo de Cultivo', description: 'Selecciona el tipo de cultivo que deseas consultar.' } },
                    { element: '#tour-container', popover: { title: 'Ver por Contenedor', description: 'Activa esta opción para desglosar la información por contenedor.' } },
                    { element: '#tour-table', popover: { title: 'Resultados', description: 'Aquí se mostrarán los datos filtrados. Puedes ordenar y paginar los resultados.' } },
                    { element: 'header .v-toolbar__content button:has(.mdi-file-excel)', popover: { title: 'Exportar a Excel', description: 'Haz clic en los 3 puntos para descargar el reporte actual en formato Excel.' } },
                ],
                nextBtnText: 'Siguiente',
                prevBtnText: 'Anterior',
                doneBtnText: 'Finalizar',
            });
        },
        methods:{
            startTour() {
                this.driverObj.drive();
            },
            load() {
                console.log("ingresando a la funcion load()");
				console.log("this.filter", this.filter);
                this.loading = true;
				this.filter.ShowContainers = this.filter.ShowContainers ? 1 : 0;
                
                if (this.filter.ShowContainers) {
                    _sDeliveryService.report_container(this.filter, this.$fun.getUserID())
                        .then(r => {
                            console.log("r.data report_container", r.data);
                            const d = r.data || {};
                            this.containerReportData = {
                                containers: (d.Containers || d.containers || []).map(c => ({
                                    departureWeek: c.DepartureWeek || c.departureWeek,
                                    arrivalWeek: c.ArrivalWeek || c.arrivalWeek,
                                    shippingLine: c.ShippingLine || c.shippingLine,
                                    vessel: c.Vessel || c.vessel,
                                    container: c.Container || c.container,
                                    etd: c.ETD || c.etd || c.Etd,
                                    eta: c.ETA || c.eta || c.Eta,
                                    rta: c.RTA || c.rta || c.Rta,
                                    isEtaFromExcel: c.IsEtaFromExcel !== undefined ? c.IsEtaFromExcel : (c.isEtaFromExcel !== undefined ? c.isEtaFromExcel : false),
                                    isRtaFromExcel: c.IsRtaFromExcel !== undefined ? c.IsRtaFromExcel : (c.isRtaFromExcel !== undefined ? c.isRtaFromExcel : false)
                                })),
                                detail: (d.Detail || d.detail || []).map(i => ({
                                    sizes: i.Sizes || i.sizes,
                                    fpb: i.FPB !== undefined && i.FPB !== null ? i.FPB : (i.fpb !== undefined && i.fpb !== null ? i.fpb : null),
                                    location: i.Location || i.location,
                                    typeOfCrop: i.TypeOfCrop || i.typeOfCrop,
                                    variety: i.Variety || i.variety,
                                    kg: i.Kg !== undefined && i.Kg !== null ? i.Kg : (i.kg !== undefined && i.kg !== null ? i.kg : null),
                                    container: i.Container || i.container,
                                    pl: i.PL || i.pl || i.Pl
                                })),
                                totalByContainer: (d.TotalByContainer || d.totalByContainer || []).map(t => ({
                                    container: t.Container || t.container,
                                    total: t.Total || t.total
                                })),
                                grandTotal: d.GrandTotal || d.grandTotal || 0
                            };
                        })
                        .catch(error => {
                            console.error("Error al cargar datos container:", error);
                             this.containerReportData = {
                                containers: [],
                                detail: [],
                                totalByContainer: [],
                                grandTotal: 0
                            };
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    _sDeliveryService.report(this.filter, this.$fun.getUserID())
                        .then(r => {
                            console.log("r.data", r.data);
                            const data = r.data;

                            if (Array.isArray(data) && data.length > 0) {

                                this.headers = Object.keys(data[0])
                                    .map(key => ({
                                        text: key.replace(/_/g, ' ').toUpperCase(),
                                        value: key
                                    }));

                                console.log("this.headers", this.headers);
                            } else {
                                this.headers = [];
                            }
                            
                            this.items = data;
                        })
                        .catch(error => {
                            console.error("Error al cargar datos:", error);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
			debouncedLoad() {
                clearTimeout(this.debounceTimer);
                
                this.debounceTimer = setTimeout(() => {
                    this.load();
                }, 300);
            },
			clickSearch() {
				this.debouncedLoad();
			},
			downloadExcel() {
				this.filter.ShowContainers = this.filter.ShowContainers ? 1 : 0;
                
                if (this.filter.ShowContainers) {
                    _sDeliveryService.excel_container(this.filter, this.$fun.getUserID())
                        .then(r => {
                            this.$fun.downloadFile(r.data, this.$const.TypeFile.EXCEL, 'Report_Container_Deliveries');
                        });
                } else {
                    _sDeliveryService.excel(this.filter, this.$fun.getUserID())
                        .then(r => {
                            this.$fun.downloadFile(r.data, this.$const.TypeFile.EXCEL, 'Report_Deliveries');
                        });
                }
            },
        },
    }
</script>